// Lista de Estados (UF) do Brasil
export const ESTADOS_BR = [
  { uf: 'AC', nome: 'Acre' },
  { uf: 'AL', nome: 'Alagoas' },
  { uf: 'AP', nome: 'Amapá' },
  { uf: 'AM', nome: 'Amazonas' },
  { uf: 'BA', nome: 'Bahia' },
  { uf: 'CE', nome: 'Ceará' },
  { uf: 'DF', nome: 'Distrito Federal' },
  { uf: 'ES', nome: 'Espírito Santo' },
  { uf: 'GO', nome: 'Goiás' },
  { uf: 'MA', nome: 'Maranhão' },
  { uf: 'MT', nome: 'Mato Grosso' },
  { uf: 'MS', nome: 'Mato Grosso do Sul' },
  { uf: 'MG', nome: 'Minas Gerais' },
  { uf: 'PA', nome: 'Pará' },
  { uf: 'PB', nome: 'Paraíba' },
  { uf: 'PR', nome: 'Paraná' },
  { uf: 'PE', nome: 'Pernambuco' },
  { uf: 'PI', nome: 'Piauí' },
  { uf: 'RJ', nome: 'Rio de Janeiro' },
  { uf: 'RN', nome: 'Rio Grande do Norte' },
  { uf: 'RS', nome: 'Rio Grande do Sul' },
  { uf: 'RO', nome: 'Rondônia' },
  { uf: 'RR', nome: 'Roraima' },
  { uf: 'SC', nome: 'Santa Catarina' },
  { uf: 'SP', nome: 'São Paulo' },
  { uf: 'SE', nome: 'Sergipe' },
  { uf: 'TO', nome: 'Tocantins' },
]

// Municípios por UF, cadastrados manualmente (sem chamadas externas de API).
// Inicialmente contém os municípios do Rio Grande do Norte (RN).
// Outros estados podem ser adicionados progressivamente a este mapa.
export const MUNICIPIOS_POR_UF: Record<string, string[]> = {
  RN: [
    'Açu', 'Afonso Bezerra', 'Água Nova', 'Alexandria', 'Almino Afonso', 'Alto do Rodrigues',
    'Angicos', 'Antônio Martins', 'Apodi', 'Areia Branca', 'Arês', 'Augusto Severo',
    'Baía Formosa', 'Baraúna', 'Barcelona', 'Bento Fernandes', 'Bodó', 'Bom Jesus',
    'Brejinho', 'Caiçara do Norte', 'Caiçara do Rio do Vento', 'Caicó', 'Campo Redondo',
    'Canguaretama', 'Caraúbas', 'Carnaúba dos Dantas', 'Carnaubais', 'Ceará-Mirim',
    'Cerro Corá', 'Coronel Ezequiel', 'Coronel João Pessoa', 'Cruzeta', 'Currais Novos',
    'Doutor Severiano', 'Encanto', 'Equador', 'Espírito Santo', 'Extremoz', 'Felipe Guerra',
    'Fernando Pedroza', 'Florânia', 'Francisco Dantas', 'Frutuoso Gomes', 'Galinhos',
    'Goianinha', 'Governador Dix-Sept Rosado', 'Grossos', 'Guamaré', 'Ielmo Marinho',
    'Ipanguaçu', 'Ipueira', 'Itajá', 'Itaú', 'Jaçanã', 'Jandaíra', 'Janduís', 'Januário Cicco',
    'Japi', 'Jardim de Angicos', 'Jardim de Piranhas', 'Jardim do Seridó', 'João Câmara',
    'João Dias', 'José da Penha', 'Jucurutu', 'Jundiá', 'Lagoa d\'Anta', 'Lagoa de Pedras',
    'Lagoa de Velhos', 'Lagoa Nova', 'Lagoa Salgada', 'Lajes', 'Lajes Pintadas', 'Lucrécia',
    'Luís Gomes', 'Macaíba', 'Macau', 'Major Sales', 'Marcelino Vieira', 'Martins',
    'Maxaranguape', 'Messias Targino', 'Montanhas', 'Monte Alegre', 'Monte das Gameleiras',
    'Mossoró', 'Natal', 'Nísia Floresta', 'Nova Cruz', 'Olho-d\'Água do Borges', 'Ouro Branco',
    'Paraná', 'Paraú', 'Parazinho', 'Parelhas', 'Parnamirim', 'Passa e Fica', 'Passagem',
    'Patu', 'Pau dos Ferros', 'Pedra Grande', 'Pedra Preta', 'Pedro Avelino', 'Pedro Velho',
    'Pendências', 'Pilões', 'Poço Branco', 'Portalegre', 'Porto do Mangue', 'Presidente Juscelino',
    'Pureza', 'Rafael Fernandes', 'Rafael Godeiro', 'Riacho da Cruz', 'Riacho de Santana',
    'Riachuelo', 'Rio do Fogo', 'Rodolfo Fernandes', 'Ruy Barbosa', 'Santa Cruz',
    'Santa Maria', 'Santana do Matos', 'Santana do Seridó', 'Santo Antônio', 'São Bento do Norte',
    'São Bento do Trairí', 'São Fernando', 'São Francisco do Oeste', 'São Gonçalo do Amarante',
    'São João do Sabugi', 'São José de Mipibu', 'São José do Campestre', 'São José do Seridó',
    'São Miguel', 'São Miguel do Gostoso', 'São Paulo do Potengi', 'São Pedro', 'São Rafael',
    'São Tomé', 'São Vicente', 'Senador Elói de Souza', 'Senador Georgino Avelino', 'Serra de São Bento',
    'Serra do Mel', 'Serra Negra do Norte', 'Serrinha', 'Serrinha dos Pintos', 'Severiano Melo',
    'Sítio Novo', 'Taboleiro Grande', 'Taipu', 'Tangará', 'Tenente Ananias', 'Tenente Laurentino Cruz',
    'Tibau', 'Tibau do Sul', 'Timbaúba dos Batistas', 'Touros', 'Triunfo Potiguar', 'Umarizal',
    'Upanema', 'Várzea', 'Venha-Ver', 'Vera Cruz', 'Viçosa', 'Vila Flor',
  ],
}

export function getMunicipiosPorEstado(uf: string): string[] {
  return MUNICIPIOS_POR_UF[uf] || []
}
